import { Auth } from "aws-amplify";
import { getUserData } from "./API";

let sqs = null;

/**
 * Returns a promise that resolves once SQS service has been initialized.
 */
export async function createSqsService() {
  //Before instantiating SQS, we need to translate the cognito auth to the format that the AWS SDK expects
  //TODO: We should probably move this to a more global place after auth takes place since it's really more about
  //      updating the global AWS object than it is specifically for SQS.
  // Alistair Note: Attempted to move globally but caused a warning from AWS for all calls about missing credentials
  // If AWS has already been initialized, just use the existing creds
  return new Promise(async (resolve) => {
  if(AWS.config && AWS.config.credentials){
    const {accessKeyId, secretAccessKey, sessionToken} = AWS.config.credentials
    sqs = new AWS.SQS({apiVersion: '2012-11-05', region: 'us-east-1',accessKeyId,secretAccessKey, sessionToken});
    resolve();
  }else{
    const userSession = await Auth.currentAuthenticatedUser();
    const newCreds = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.AWS_IDENTITY_POOL_ID,
      Logins: {
        'cognito-idp.us-east-1.amazonaws.com/us-east-1_N2qYJf68Y': userSession.signInUserSession.getIdToken().getJwtToken()
      }
    },{region: 'us-east-1'});
    newCreds.get(function () {
      // Credentials will be available when this function is called.
      const {accessKeyId, secretAccessKey, sessionToken} = newCreds;
      sqs = new AWS.SQS({apiVersion: '2012-11-05', region: 'us-east-1',accessKeyId, secretAccessKey, sessionToken});
      resolve();
    });
  }
  })
}


export async function sendMessageToSqs(eventName, properties) {
    if(!sqs) await createSqsService();
      const userData = getUserData();
      properties.studentId = userData.userId;
      properties.firstName = userData.firstName;
      properties.userId = userData.userId;

      let segment_event = {
          "user_id": userData.userId,
          "userId": userData.userId,
          "event_name": eventName,
          "event_payload": properties,
          "eventy_type": "track",
          "providers": ["segment"]
      }
      try {
          const params = {
              MessageAttributes: {},
              MessageBody: JSON.stringify(segment_event),
              QueueUrl: process.env.SEGMENT_SERVICE_SQS_URL,
            };

            sqs.sendMessage(params, function(err, data) {
              if (err) {
                console.log("Error", err);
              } else {
                console.log("Success", data.MessageId);
              }
            });

      } catch (e) {
        console.log("Send Message Failed", params.event_name)
      }
}

export const SEGMENT_EVENTS = {
    story_completed: "story completed",
}

/**
 * helper function to send an event to SQS (amira-logging)
 * @param {[string]} providers hubspot, segment, etc
 * @param {string} eventName 
 * @param {object} payload 
 */
export async function sendEventToSqs(providers, event_name, event_payload) {
  if (!providers || providers.length === 0 || !event_name || !event_payload) {
    return console.error('invalid sendEventToSqs invocation', event_name);
  }

  // initialize SQS service if needed
  if (!sqs) await createSqsService();
  
  const eventBody = {
    event_name,
    event_payload,
    providers,
  }

  try {
    const params = {
      MessageAttributes: {},
      MessageBody: JSON.stringify(eventBody),
      QueueUrl: process.env.SEGMENT_SERVICE_SQS_URL,
    };

    sqs.sendMessage(params, (err, data) => {
      if (err) {
        console.log("Error", err);
      } else {
        console.log("Success", data.MessageId);
      }
    });
  } catch (e) {
    console.log("Send Message Failed", e)
  }
}

/**
 * Creates a contact within HubSpot, associating an email to SIS userId
 * @param {*} payload object containing email, firstname, lastname
 */
export function createHubSpotContact(payload) {
  const providers = ['hubspot'];
  const user_id = getUserData().userId;
  const event_name = 'create_contact';
  payload.user_id = user_id;
  sendEventToSqs(providers, event_name, payload);
}